import { styled } from '@mui/material/styles';

import BasicButton, { ButtonSize } from '../button/basic-button/basic-button';
import { Button } from '../button/button';

type StyledButtonProps = {
  sizeVariant?: ButtonSize;
};

export const SecondaryButton = styled(BasicButton)<StyledButtonProps>(
  ({ theme }) => {
    return {
      width: 'fit-content',
      borderRadius: theme.borderRadius?.borderRadiusSmall,
      background: theme.background?.secondaryButton,
      border: `1px solid ${theme.colors.alpha.white}`,
      boxShadow: theme.colors.shadows.actionButton2,
      minWidth: 'auto',
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
      },
    };
  }
);

export const PrimaryButton = styled(BasicButton)(({ theme }) => ({
  width: 'fit-content',
  borderRadius: theme.borderRadius?.borderRadiusSmall,
  boxShadow: theme.colors.shadows.actionButton,
  border: `1px solid ${theme.colors.alpha.white}`,
  background: theme.background?.primaryButton,
  minWidth: 'auto',
  fontWeight: '400',
}));

//Red Text
export const DestructiveButton = styled(BasicButton)(({ theme }) => {
  return {
    width: 'fit-content',
    borderRadius: theme.borderRadius?.borderRadiusSmall,
    background: theme.background?.secondaryButton,
    border: `1px solid ${theme.colors.alpha.white}`,
    boxShadow: theme.colors.shadows.actionButton2,
    minWidth: 'auto',
    color: theme.text?.validation,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  };
});

export const TertiaryButton = styled(BasicButton)(({ theme }) => {
  return {
    width: 'fit-content',
    borderRadius: theme.borderRadius?.borderRadiusSmall,
    border: `1px solid ${theme.colors.alpha.white}`,
    boxShadow: theme.colors.shadows.actionButton2,
    background: theme.background?.secondaryButton,
    minWidth: 'auto',
    fontWeight: '500',
    color: `${theme.palette.info.main}`,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  };
});
